import { render, staticRenderFns } from "./planningComponent.vue?vue&type=template&id=b7db4966&scoped=true"
import script from "./planningComponent.vue?vue&type=script&lang=js"
export * from "./planningComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7db4966",
  null
  
)

export default component.exports